// extracted by mini-css-extract-plugin
module.exports = {"title-icon":"_6c97079b1b--title-icon--oWbAv","title-icon-3":"_6c97079b1b--title-icon-3--M6Zje","title-icon-4":"_6c97079b1b--title-icon-4--Aqhp9"};